export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ScrollToLink.vue?vue&type=template&id=3a74aa39&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ScrollToLink.vue?vue&type=template&id=3a74aa39&
// module id = 200
// module chunks = 0